"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidEmail = exports.EmailSchema = void 0;
const zod_1 = require("zod");
const lodash_1 = require("lodash");
exports.EmailSchema = zod_1.z.string().email();
/**
 * Verifies if the provided email is a valid email address
 * @returns true if valid, false otherwise.
 */
function isValidEmail(email) {
    if ((0, lodash_1.isNil)(email)) {
        return false;
    }
    return exports.EmailSchema.safeParse(email).success;
}
exports.isValidEmail = isValidEmail;
//# sourceMappingURL=email.type.js.map